import { useTranslation } from 'react-i18next';

export default function PrixTypiques() {
  const { t } = useTranslation('charny');

  const rows = [
    { type: t('prix_row_1_type'), price: t('prix_row_1_price') },
    { type: t('prix_row_2_type'), price: t('prix_row_2_price') },
    { type: t('prix_row_3_type'), price: t('prix_row_3_price') },
    { type: t('prix_row_4_type'), price: t('prix_row_4_price') },
  ];

  return (
    <section className="py-14 md:py-20 bg-[#F4F5F7]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1B2A4E] mb-8 md:mb-10 text-center">
          {t('prix_h2')}
        </h2>

        <div className="bg-white rounded-lg border border-gray-100 overflow-hidden max-w-3xl mx-auto">
          <div className="grid grid-cols-2 bg-[#1B2A4E] text-white text-sm font-semibold">
            <div className="px-5 py-3.5">{t('prix_table_type')}</div>
            <div className="px-5 py-3.5 text-right">{t('prix_table_price')}</div>
          </div>
          {rows.map((r, idx) => (
            <div
              key={idx}
              className={`grid grid-cols-2 text-sm ${idx % 2 === 0 ? 'bg-white' : 'bg-[#F8F9FB]'}`}
            >
              <div className="px-5 py-3.5 text-[#1B2A4E] font-medium border-r border-gray-50">{r.type}</div>
              <div className="px-5 py-3.5 text-[#4A5568] text-right">{r.price}</div>
            </div>
          ))}
        </div>

        <p className="text-xs text-[#4A5568]/70 text-center mt-4 max-w-3xl mx-auto">
          {t('prix_note')}
        </p>
      </div>
    </section>
  );
}